module.exports = __webpack_public_path__ + "img/icon_firmware_active.86d7b0f0.svg";